// extracted by mini-css-extract-plugin
module.exports = {"content":"DeviationType_content__11w0q","submitBtn":"DeviationType_submitBtn__Nlzha"};